// Import the necessary components
import VerofreshRecord from './VerofreshRecord'
import { get } from 'lodash'

class EnergyPriceSetRecord extends VerofreshRecord {
  /**
   * @return array
   */
  static get types () {
    return ['diesel', 'gasoline', 'ethanol', 'natural_gas', 'electric']
  }

  /**
   * @return array
   */
  /* eslint-disable-next-line camelcase */
  static get units_of_measure () {
    return ['liter', 'gallon', 'kWh']
  }

  /**
   * @return array
   */
  static get currencies () {
    return ['AFN', 'ALL', 'DZD', 'USD', 'EUR', 'AOA', 'XCD', 'ARS', 'AMD', 'AWG', 'AUD', 'AZN', 'BSD', 'BHD', 'BDT', 'BBD', 'BYN', 'BZD', 'XOF', 'BMD', 'BTN', 'INR', 'BOB', 'BOV', 'BAM', 'BWP', 'NOK', 'BRL', 'BND', 'BGN', 'BIF', 'CVE', 'KHR', 'XAF', 'CAD', 'KYD', 'CLF', 'CLP', 'CNY', 'COP', 'COU', 'KMF', 'CDF', 'NZD', 'CRC', 'HRK', 'CUC', 'CUP', 'ANG', 'CZK', 'DKK', 'DJF', 'DOP', 'EGP', 'SVC', 'ERN', 'ETB', 'FKP', 'FJD', 'XPF', 'GMD', 'GEL', 'GHS', 'GIP', 'GTQ', 'GBP', 'GNF', 'GYD', 'HTG', 'HNL', 'HKD', 'HUF', 'ISK', 'IDR', 'XDR', 'IRR', 'IQD', 'ILS', 'JMD', 'JPY', 'JOD', 'KZT', 'KES', 'KPW', 'KRW', 'KWD', 'KGS', 'LAK', 'LBP', 'LSL', 'ZAR', 'LRD', 'LYD', 'CHF', 'MOP', 'MGA', 'MWK', 'MYR', 'MVR', 'MRU', 'MUR', 'XUA', 'MXN', 'MXV', 'MDL', 'MNT', 'MAD', 'MZN', 'MMK', 'NAD', 'NPR', 'NIO', 'NGN', 'OMR', 'PKR', 'PAB', 'PGK', 'PYG', 'PEN', 'PHP', 'PLN', 'QAR', 'MKD', 'RON', 'RUB', 'RWF', 'SHP', 'WST', 'STN', 'SAR', 'RSD', 'SCR', 'SLL', 'SGD', 'XSU', 'SBD', 'SOS', 'SSP', 'LKR', 'SDG', 'SRD', 'SZL', 'SEK', 'CHE', 'CHW', 'SYP', 'TWD', 'TJS', 'TZS', 'THB', 'TOP', 'TTD', 'TND', 'TRY', 'TMT', 'UGX', 'UAH', 'AED', 'USN', 'UYI', 'UYU', 'UZS', 'VUV', 'VEF', 'VND', 'YER', 'ZMW', 'ZWL']
  }

  /**
   * Returns the most recent price in the price history
   * @return float|undefined
   */
  /* eslint-disable-next-line camelcase */
  get most_recent_price () {
    const priceHistory = get(this, 'price_history', [])
    return priceHistory.length > 0 ? priceHistory[priceHistory.length - 1].price : undefined
  }

  /**
   * Assigns the user the given customer
   *
   * @param int customerId
   * @return promise
   */
  assignCustomer (customerId) {
    return this._mapper()
      .datastore
      .getMapper('EnergyPriceSet')
      .assignCustomer({
        energy_price_set_id: this.id,
        data: {
          energy_price_set_id: this.id,
          customer_id: customerId
        }
      })
  }

  /**
     * Removes the user from the given customer
     *
     * @param int customerId
     * @return promise
     */
  removeCustomer (customerId) {
    return this._mapper()
      .datastore
      .getMapper('EnergyPriceSet')
      .removeCustomer({
        energy_price_set_id: this.id,
        customer_id: customerId
      })
  }
}

// Actions allow us to defined additional calls we can make to related
// endpoints.
const actions = {
  assignCustomer: {
    method: 'POST',
    getEndpoint: function (BaseMapper, options) {
      const basePath = BaseMapper.getAdapter(BaseMapper.defaultAdapter).basePath
      const endpoint = BaseMapper.endpoint
      return `${basePath}/${endpoint}/${options.energy_price_set_id}/customer`
    },
    response (response) {
      return response.data
    }
  },
  removeCustomer: {
    method: 'DELETE',
    getEndpoint: function (BaseMapper, options) {
      const basePath = BaseMapper.getAdapter(BaseMapper.defaultAdapter).basePath
      const endpoint = BaseMapper.endpoint
      return `${basePath}/${endpoint}/${options.energy_price_set_id}/customer/${options.customer_id}`
    },
    response (response) {
      return response.data
    }
  }
}

const relations = {
  hasMany: {
    Customer: {
      foreignKey: 'id',
      localField: 'customers'
    }
  }
}

export default EnergyPriceSetRecord
export { actions, relations }
